export class Person {
    PersonId?: number;
    FirstName?: string;
    LastName?: string;
    FullName?: string;
    Email: string;
    IsActive?: boolean;
    Phone?: string;
    IsPreReg?: boolean;
    IsLocked?: boolean;
    LoginEnabled?: boolean;
}
